/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CartRequestBuilderNavigationMetadata, CartRequestBuilderRequestsMetadata, type CartRequestBuilder } from './cart/index.js';
// @ts-ignore
import { CatalogRequestBuilderNavigationMetadata, type CatalogRequestBuilder } from './catalog/index.js';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';

/**
 * Instantiates a new {@link OrderApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createOrderApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    let serializationWriterFactory : SerializationWriterFactoryRegistry
    let parseNodeFactoryRegistry : ParseNodeFactoryRegistry
    
    if (requestAdapter.getParseNodeFactory() instanceof ParseNodeFactoryRegistry) {
        parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry
    } else {
        throw new Error("requestAdapter.getParseNodeFactory() is not a ParseNodeFactoryRegistry")
    }
    
    if (requestAdapter.getSerializationWriterFactory() instanceof SerializationWriterFactoryRegistry) {
        serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry
    } else {
        throw new Error("requestAdapter.getSerializationWriterFactory() is not a SerializationWriterFactoryRegistry")
    }
    
    
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    if (requestAdapter.baseUrl === undefined || requestAdapter.baseUrl === null || requestAdapter.baseUrl === "") {
        requestAdapter.baseUrl = "http://localhost:5138";
    }
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<OrderApiClient>(requestAdapter, pathParameters, OrderApiClientNavigationMetadata, undefined);
}
/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface OrderApiClient extends BaseRequestBuilder<OrderApiClient> {
    /**
     * The cart property
     */
    get cart(): CartRequestBuilder;
    /**
     * The catalog property
     */
    get catalog(): CatalogRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrderApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderApiClientNavigationMetadata: Record<Exclude<keyof OrderApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cart: {
        requestsMetadata: CartRequestBuilderRequestsMetadata,
        navigationMetadata: CartRequestBuilderNavigationMetadata,
    },
    catalog: {
        navigationMetadata: CatalogRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
